import { render, staticRenderFns } from "./ReceiptTableTransactionDetails.vue?vue&type=template&id=17fc6e4c&scoped=true&"
import script from "./ReceiptTableTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./ReceiptTableTransactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptTableTransactionDetails.vue?vue&type=style&index=0&id=17fc6e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fc6e4c",
  null
  
)

export default component.exports